module.exports = __webpack_public_path__ + "static/media/GettyImages-1059166634.1b10ed5b.jpg";